export default function Slug({
  id = null,
  type = null,
  target = null,
  // code = null,
  // timestamp = + new Date(),
  // isFetching = false
}) {
  this._id = id
  this._type = type
  this._target = target
  // this._code = code
  // this._timestamp = timestamp
  // this._isFetching = isFetching
}

Slug.prototype.getId = function() {
  return this._id
}

Slug.prototype.setId = function(id) {
  this._id = id
}

Slug.prototype.getType = function() {
  return this._type
}

Slug.prototype.sesType = function(type) {
  this._type = type
}

Slug.prototype.getTarget = function() {
  return this._target
}

Slug.prototype.setTarget = function(target) {
  this._target = target
}

// Slug.prototype.getCode = function() {
//   return this._code
// }

// Slug.prototype.setCode = function(code) {
//   this._code = code
// }

// Slug.prototype.getTimestamp = function() {
//   return this._timestamp
// }

// Slug.prototype.setTimestamp = function(timestamp) {
//   this._timestamp = timestamp
// }

// Slug.prototype.getIsFetching = function() {
//   return this._isFetching
// }

// Slug.prototype.setIsFetching = function(isFetching) {
//   this._isFetching = isFetching
// }



// WEBPACK FOOTER //
// ./src/entities/Slug.js